import { Reveal } from "@/components/Reveal";
import { STEPS } from "@/data/content";

export const HowItWorks = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="bg-[#111111] text-[#F7F5F0] py-24 sm:py-32 lg:py-44 relative film-grain"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 relative z-[2]">
        <div className="max-w-2xl mb-20 sm:mb-28">
          <Reveal>
            <p className="overline mb-6 text-[#C9BCA8]">How It Works</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
              Three steps from still to cinema.
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#F7F5F0]/15">
          {STEPS.map((step, i) => (
            <Reveal
              key={step.num}
              delay={i * 0.12}
              className="bg-[#111111] p-9 sm:p-12 lg:p-14"
            >
              <div className="font-display text-5xl sm:text-6xl text-accent/90 font-light">
                {step.num}
              </div>
              <h3 className="mt-10 font-display font-light text-2xl sm:text-3xl leading-snug">
                {step.title}
              </h3>
              <p className="mt-5 text-[#F7F5F0]/60 leading-relaxed text-sm sm:text-base">
                {step.body}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
